import { useHistory, useParams } from "react-router-dom"
import { Route } from "react-router-dom";

import Button from "components/global/Button";
import ConfirmModal from "components/global/ConfirmModal";
import ImgWrapper from "components/global/ImgWrapper";
import Loader from "components/global/Loader";
import Spacer from "components/global/Spacer";
import { connect } from "react-redux";
import connectFacebook from "assets/icons/connect_facebook.png";
import connectInstagram from "assets/icons/connect_instagram.png";
import connectTiktok from "assets/icons/connect_tiktok.png";
import facebookIcon from "assets/icons/facebookIcon.svg";
import facebookIconCircle from "assets/icons/facebookIconCircle.svg";
import instagramIcon from "assets/icons/instagramIcon.svg";
import instagramIconCircle from "assets/icons/instagramDefault.svg";
import linkedinIcon from "assets/icons/linkedinIcon.svg";
import linkedinIconCircle from "assets/icons/linkedinIconCircle.svg";
import { capitalizeFirstLetter } from "utils/utils";
import twitterIcon from "assets/icons/twitterIcon.svg";
import twitterIconCircle from "assets/icons/twitterIconCircle.svg";
import tiktokCircle from "assets/icons/tiktok-circle.svg";
import tiktokIcon from "assets/icons/tiktokIcon.svg";
import { useClickOutside } from "webrix/hooks";
import userIcon from "assets/icons/userIconWhite.svg";
import youtubeIcon from "assets/icons/youtubeIcon.svg";
import youtubeIconCircle from "assets/icons/youtubeIconCircle.svg";
import PLANS from "assets/data/PLANS.json";

import { ManageChannelsWrapper, ConnectInfo } from "./ManageChannelsStyles";
import SelectAccountModal from "./SelectAccountModal";
import useManageChannels from "hooks/useManageChannels";
import usePageTitle from "hooks/usePageTitle";
import Channels from "./Channels";

export const socialIcons = {
  default: {
    facebook: facebookIcon,
    twitter: twitterIcon,
    linkedin: linkedinIcon,
    youtube: youtubeIcon,
    instagram: instagramIcon,
    tiktok: tiktokIcon,
  },
  circle: {
    facebook: facebookIconCircle,
    twitter: twitterIconCircle,
    linkedin: linkedinIconCircle,
    youtube: youtubeIconCircle,
    instagram: instagramIconCircle,
    tiktok: tiktokCircle,
  },
};

export const ConnectedOptions = ({
  handleRefresh,
  handleRemove,
  toggleShowOptions,
  dataId,
  channel,
}) => {
  const handleMouseDownCapture = useClickOutside(() => {
    toggleShowOptions("");
  });

  return (
    <div
      className="options"
      data-id={dataId}
      onMouseDownCapture={handleMouseDownCapture}
    >
      <button
        type="button"
        className="actionBtn textLeft"
        onClick={() => handleRefresh(channel)}
        // disabled={account.is_access_token_valid}
      >
        Refresh connection
      </button>
      <button
        type="button"
        className="actionBtn textLeft"
        onClick={() => handleRemove(channel)}
      >
        Remove channel
      </button>
    </div>
  );
};

const ManageChannels = ({ active_account }) => {
  usePageTitle("Manage channels");
  const router = useHistory();
  const { brandId } = useParams();
  const {
    loadSocials,
    socials,
    brand,
    platformList,
    removeSocial,
    handleRemoveChannel,
    toggleShowOptions,
    handleTokenRefresh,
    handleConnectPlatform,
    loading,
    connecting,
  } = useManageChannels(brandId);

  const planName = active_account?.current_subscription.plan_name;
  const planLimit =
    brand?.brand_subscription_details?.channel?.numberOfChannelConnectionLeft;

  const path = `/dashboard/brands/${brandId}/channels`;

  // if(active_brand?.id !== Number(brandId)) {
  //   router.push("/dashboard/brands")
  // }
  
  return (
    <ManageChannelsWrapper>
      <ConfirmModal
        id="confirmPlatformRemoval"
        action="remove this social media channel"
        title={
          [1, 0].includes(planLimit) ? "You're nearing your plan limit" : ""
        }
        description={
          [1, 0].includes(planLimit)
            ? `${capitalizeFirstLetter(planName)} plan allows ${
                PLANS[planName].socialMediaChanges
              } changes to social media channels. If both are used and this channel is removed, adding another is not possible.`
            : "Removing this channel means you won't be able to post to it from PostPaddy."
        }
        actionText="Remove"
        callback={() => removeSocial()}
        warning={[1, 0].includes(planLimit)}
      />
      <ConnectInfo className="connectInstagramInfo flexRow alignCenter justifyCenter">
        <div className="card">
          <img src={connectInstagram} alt="." className="image" />
          <Spacer y={2.4} />
          <h4>Authenticate with Facebook</h4>
          <Spacer y={2.4} yMobile={1.2} />
          <p className="l2">
            Wait...why do I have to authenticate with Facebook?
          </p>
          <Spacer y={1.2} />
          <p className="l2 colorBodyText">
            Facebook only permits third-party applications access to an
            Instagram business account. Visit your Instagram profile to switch
            your personal account to a business account.
          </p>
          <Spacer y={0.6} />
          <p className="l2 colorBodyText">
            Next, Facebook also requires that your Instagram business account is
            connected to a Facebook page.
          </p>
          <Spacer y={1.2} />
          <p className="l2">After ensuring these things, what happens next?</p>
          <Spacer y={1.2} />
          <p className="l2 colorBodyText">
            Once you click “Authenticate”, sign in to your Facebook account that
            has permissions to the Facebook page to which the Instagram business
            account is connected.
          </p>
          <Spacer y={2.4} />
          <div className="flexRow justifySpaceBetween">
            <button
              className="btn cancel flexRow alignCenter justifyCenter"
              onClick={() =>
                document
                  .querySelector(".connectInstagramInfo")
                  .classList.remove("show")
              }
            >
              Cancel
            </button>
            <Spacer x={2.4} />
            <button
              onClick={() => handleConnectPlatform("instagram")}
              className="btn actionBtn flexRow alignCenter justifyCenter"
              disabled={connecting}
            >
              Authenticate
            </button>
          </div>
        </div>
      </ConnectInfo>
      <ConnectInfo className="connectFacebookInfo flexRow alignCenter justifyCenter">
        <div className="card">
          <img src={connectFacebook} alt="." className="image" />
          <Spacer y={2.4} />
          <h4>Connecting PostPaddy to your Facebook page</h4>
          <Spacer y={2.4} yMobile={1.2} />
          <p className="l2 colorBodyText">
            Note that Facebook only allows third-party applications access to
            post on your Facebook page(s), not on your personal timeline.
          </p>
          <Spacer y={0.6} />
          <p className="l2 colorBodyText">
            Please grant all requested permissions for your Facebook pages to
            enjoy the best experience using PostPaddy.
          </p>
          <Spacer y={2.4} />
          <div className="flexRow justifySpaceBetween">
            <button
              className="btn cancel flexRow alignCenter justifyCenter"
              onClick={() =>
                document
                  .querySelector(".connectFacebookInfo")
                  .classList.remove("show")
              }
            >
              Cancel
            </button>
            <Spacer x={2.4} />
            <button
              onClick={() => handleConnectPlatform("facebook")}
              className="btn actionBtn flexRow alignCenter justifyCenter"
              disabled={connecting}
            >
              Continue
            </button>
          </div>
        </div>
      </ConnectInfo>
      {/* tiktok connect info */}
      <ConnectInfo className="connectTiktokInfo flexRow alignCenter justifyCenter">
        <div className="card">
          <img src={connectTiktok} alt="." className="image" />
          <Spacer y={2.4} />
          <h5>Connect your TikTok Business account to PostPaddy</h5>
          <Spacer y={1.2} />
          <p className="l3 colorBodyText">
            To maximize PostPaddy's features, connect your TikTok business account. Follow the steps below to convert 
            your personal account to a business account:
          </p>
          <Spacer y={0.6} />
          <ol className="list-items">
            <li>Log in to your TikTok account in the TikTok mobile app.</li>
            <li>Open your profile from the lower right-hand corner.</li>
            <li>Tap the three lines or dots in the upper right-hand corner.</li>
            <li>Go to Settings and Privacy, then select Account.</li>
            <li>Tap Switch to Business Account, followed by Next.</li>
            <li>Choose your business category and save your selection.</li>
          </ol>
          <Spacer y={2.4} />
          <div className="flexRow justifySpaceBetween">
            <button
              className="btn cancel flexRow alignCenter justifyCenter"
              onClick={() =>
                document
                  .querySelector(".connectTiktokInfo")
                  .classList.remove("show")
              }
            >
              Cancel
            </button>
            <Spacer x={2.4} />
            <button
              onClick={() => handleConnectPlatform("tiktok")}
              className="btn actionBtn flexRow alignCenter justifyCenter"
              disabled={connecting}
            >
              Continue
            </button>
          </div>
        </div>
      </ConnectInfo>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flexRow alignCenter">
            <ImgWrapper size={5.6} imgHeight={brand?.avatar ? "100%" : "2.4rem"}>
              {brand?.avatar ? (
                <img src={`${brand?.avatar}`} alt="AVI" />
              ) : (
                <img src={userIcon} alt="avatar" id="photoOutput" />
              )}
            </ImgWrapper>
            <Spacer x={1.2} />
            <h5 className="l1-large">{brand?.name}</h5>
          </div>
          <Spacer y={2.4} />
          <h5 className="colorGrey1 title">
            Link brand's social media channels
          </h5>
          <Spacer y={0.6} yMobile={0.2} />
          <p className="l3 colorBodyText descrciption">
            Connect your social media channels and enjoy seamless posting and
            scheduling.
          </p>
          <Spacer y={2.4} />
          <Channels
            socials={socials}
            platformList={platformList}
            brandId={brand?.id}
            handleConnectPlatform={handleConnectPlatform}
            handleTokenRefresh={handleTokenRefresh}
            handleRemoveChannel={handleRemoveChannel}
            toggleShowOptions={toggleShowOptions}
            canConnectChannel={{
              facebook:
                brand?.brand_subscription_details?.channel?.canConnectFacebook,
              linkedin:
                brand?.brand_subscription_details?.channel?.canConnectLinkedIn,
              instagram:
                brand?.brand_subscription_details?.channel?.canConnectInstagram,
              twitter:
                brand?.brand_subscription_details?.channel?.canConnectTwitter,
              youtube:
                brand?.brand_subscription_details?.channel?.canConnectYoutube,
              tiktok:
                brand?.brand_subscription_details?.channel?.canConnectTikTok,
            }}
            connecting={connecting}
          />
          <Spacer y={2.4} />

          <Button
            type="button"
            text="Done"
            className="doneBtn"
            onClick={async () => {
              router.push(`/dashboard/brands`);
            }}
            disabled={!platformList?.length}
          />
        </>
      )}

      {/* Select account/page modal */}
      <Route
        exact
        path={`${path}/select-account`}
        component={() => (
          <SelectAccountModal
            brand={brand}
            path={path}
            loadSocials={loadSocials}
          />
        )}
      />
    </ManageChannelsWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
    user_token: state.user_token,
  };
};

export default connect(mapStateToProps)(ManageChannels);
